export const getBaseUrl = () => {
  return process.env.REACT_APP_API_URL+'/xa';
};

export const getPaymentUrl = () => {
  return process.env.REACT_APP_PAYMENTS_API_URL;
}